module.exports = __webpack_public_path__ + "img/chaos_warrior_small.a1230b1c.png";